import { render, staticRenderFns } from "./block-inputs-new.vue?vue&type=template&id=2f78948c&scoped=true&"
import script from "./block-inputs-new.vue?vue&type=script&lang=ts&"
export * from "./block-inputs-new.vue?vue&type=script&lang=ts&"
import style0 from "./block-inputs-new.vue?vue&type=style&index=0&id=2f78948c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78948c",
  null
  
)

export default component.exports